const empresa = localStorage.getItem('empresa');
export const showNotificationSpeech = (contrato) => {
    return new Promise((resolve) => {
        if (!('speechSynthesis' in window)) {
            console.warn("La API de SpeechSynthesis no esta disponible en este navegador.");
            resolve();
            return;
        }

        let mensaje = ``;
        if (empresa == 2) {
            mensaje = `${contrato.Notificacion}`;
        } else {
            mensaje = `${contrato.NotificacionCliente}`;
        }

        const utterance = new SpeechSynthesisUtterance(mensaje);
        utterance.lang = 'es-ES';
        utterance.rate = 1;
        utterance.pitch = 1;
        utterance.onend = () => resolve();
        utterance.onerror = () => resolve();

        let voices = window.speechSynthesis.getVoices();
        const applyVoiceAndSpeak = () => {
            const sabinaVoice = voices.find(voice => voice.name === 'Microsoft Sabina - Spanish (Mexico)');
            if (sabinaVoice) {
                utterance.voice = sabinaVoice;
            }
            window.speechSynthesis.speak(utterance);
        };

        // Si ya se han cargado las voces
        if (voices.length > 0) {
            applyVoiceAndSpeak();
        } else {
            // En algunos navegadores las voces pueden cargarse de forma asincrona
            const prevHandler = window.speechSynthesis.onvoiceschanged;
            window.speechSynthesis.onvoiceschanged = () => {
                voices = window.speechSynthesis.getVoices();
                applyVoiceAndSpeak();
                window.speechSynthesis.onvoiceschanged = prevHandler || null;
            };
        }
    });
};

export const logAvailableVoices = () => {
    let voices = window.speechSynthesis.getVoices();
    if (voices.length > 0) {
        // console.log("Voces disponibles:", voices);
    } else {
        window.speechSynthesis.onvoiceschanged = () => {
            voices = window.speechSynthesis.getVoices();
            // console.log("Voces disponibles:", voices);
        };
    }
};
